export const TINYMCE_KEY = '4hesrnei4e1kdyap76fx358etn2kmtg4kpye90wxuagrsar1';
